<template>
  <CDropdown addMenuClasses="mcustom-menu overflow-auto" :show="showMe">
    <template v-slot:toggler>
      <CInput
        addLabelClasses="text-muted font-weight-bold"
        :label="label"
        :class="disabled ? 'disabled' : ''"
        :disabled="disabled"
        :value.sync="search"
        :placeholder="label"
        :isValid="required ? options.some(option => option.label == search) : null"
        @input="showOnTyping"
        @blur="onBlur">
        <template v-if="prepend_content" #prepend-content>
          <template v-if="typeof prepend_content === 'string'">
            {{ prepend_content }}
          </template>
          <template v-if="typeof prepend_content === 'object'">
            <BCIcon :type="prepend_content.type" :name="prepend_content.name" />
          </template>
        </template>
      </CInput>
    </template>
    <template v-if="filteredOptions.length == 0">
      <CDropdownItem>Sin resultados</CDropdownItem>
    </template>
    <template v-if="filteredOptions.length > 0">
      <CDropdownItem 
      v-for="(option, index) in filteredOptions"
        :key="index"
        @click="selected(option)">
        {{ option.label }}
      </CDropdownItem>
    </template>
  </CDropdown>
</template>

<style>
  .mcustom-menu {
    max-height: 25vw;
  }
</style>

<script>
  import BCIcon from "./BCIcon.vue";

  export default {
    name: "CAutocomplete",
    components: { BCIcon },
    props: {
      value: {
        type: [String, Number, null],
        default: null
      },
      options: {
        type: Array,
        default: () => []
      },
      label: {
        type: String,
        default: ""
      },
      required: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      },
      prepend_content: {
        type: [Boolean, Object, String],
        default: false
      }
    },
    data() {
      return {
        search: "",
        showMe: false
      };
    },
    watch: {
      value: {
        immediate: true,
        handler(newValue) {
          this.search = this.getLabelByValue(newValue);
        }
      }
    },
    methods: {
      selected(option) {
        this.search = option.label;
        this.$emit("update:input", option.value);
        this.$emit("input", option.value);
      },
      getLabelByValue(value) {
        const selected = this.options.find(option => option.value == value);
        return selected ? selected.label : "";
      },
      showOnTyping(value) {
        this.search = value;
        this.showMe = value.length > 2;
        this.$emit("update-search", value);
      },
      onBlur() {
        if (!this.search) {
          this.$emit("update:input", "");
        }
      }
    },
    computed: {
      filteredOptions() {
        const query = this.search ? this.search.toLowerCase() : "";
        return this.options.filter(option => option.label.toLowerCase().includes(query));
      }
    }
  };
</script>
